import { ISuggestionGroup } from '../../../../../types/suggestions';

export const getDescription = (suggest: ISuggestionGroup): string | undefined => {
  return suggest.type === 'newobject' ? suggest.fullAddress : undefined;
};
